import Vue from 'vue'
import App from './App.vue'
import i18nOptions from './i18n'
import Login from './components/common/login/Login.vue'
import ResetEmail from './components/common/login/ResetEmail.vue'
import ResetPassword from './components/common/login/ResetPassword.vue'
import TokenLogin from './components/common/login/TokenLogin.vue'
import Selection from './components/common/selection/Selection.vue'
import Bandwidth from './components/common/test/Bandwidth.vue'
import VueRouter from 'vue-router'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import VueChatScroll from 'vue-chat-scroll'
import VueTooltip from 'v-tooltip'
import VueI18n from 'vue-i18n'
import WhitelabelConfig from './services/whitelabel'

import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import './assets/scss/main.scss'

// Make whitelabel config globally available
Vue.prototype.$whitelabel = WhitelabelConfig

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(VueRouter)
Vue.use(VueChatScroll)
Vue.use(VueTooltip)
Vue.use(VueI18n)

Vue.filter('formatDuration', function (value) {
    if (value !== '') {
      var time = value.split(':')
      var finalTime = ''

      if (time[0] !== '00') {
        finalTime = finalTime + parseInt(time[0]) + 'h '
      }
      if (time[1] !== '00') {
        finalTime = finalTime + parseInt(time[1]) + 'm '
      }
      finalTime = finalTime + parseInt(time[2]) + 's'

      return finalTime
    }
    return '0s'
})

Vue.filter('formatDurationLength', function (value) {
    if (value !== '' && value) {
      var finalTime = ''

      var hours   = Math.floor(value / 3600)
      var minutes = Math.floor((value - (hours * 3600)) / 60)
      var seconds = value - (hours * 3600) - (minutes * 60)

      if (hours > 0) {
        finalTime = finalTime + hours + 'h '
      }
      if (minutes > 0) {
        finalTime = finalTime + minutes + 'm '
      }
      finalTime = finalTime + seconds + 's'

      return finalTime
    }
    return '0s'
})

Vue.filter('formatTimestamp', function (value, ampm, today, yesterday) {
    var day = value.split(' ')[0]
    var date = value.split(' ')[1]
    var year = value.split(' ')[2]

    var formatedDate = `${day} ${date} ${year}`

    if (formatedDate === today) {
      formatedDate = 'Today'
    } else if (formatedDate === yesterday) {
      formatedDate = 'Yesterday'
    }

    var time = value.split(' ')[3]
    var finalTimestamp = ''

    if (ampm) {
      var hour = parseInt(time.split(':')[0])
      var minute = time.split(':')[1]
      var formatedHour = hour > 12 ? hour - 12 : hour
      formatedHour = formatedHour <= 9 ? `0${formatedHour}` : formatedHour

      finalTimestamp = `${formatedDate} ${formatedHour}:${minute} ${hour > 11 ? 'pm' : 'am'}`
    } else {
      finalTimestamp = `${formatedDate} ${time.split(':')[0]}:${time.split(':')[1]}`
    }

    return finalTimestamp
})

Vue.filter('formatTime', function (value, today, yesterday, splitter = 'T') {
    if (value) {
      value = value.toLocaleString("en-US", {timeZone: "America/New_York"})
      var first = value.split(splitter)[0]
      var second = value.split(splitter)[1]
      var day = first.split('-')[2]
      var date = first.split('-')[1]
      var year = first.split('-')[0]

      var formatedDate = `${day} ${date} ${year}`

      if (formatedDate === today) {
        formatedDate = ''
      } else if (formatedDate === yesterday) {
        formatedDate = 'Yesterday '
      } else {
        formatedDate = `${date}/${day} `
      }

      var finalTimestamp = ''

      finalTimestamp = `${formatedDate}${second.split(':')[0]}:${second.split(':')[1]}`

      return finalTimestamp
    }
    return ''
})

Vue.filter('formatDate', function (value, today, yesterday) {
    if (value) {
      value = value.toLocaleString("en-US", {timeZone: "America/New_York"})
      var first = value.split('T')[0]
      var second = value.split('T')[1]
      var day = first.split('-')[2]
      var date = first.split('-')[1]
      var year = first.split('-')[0]

      var formatedDate = `${day} ${date} ${year}`

      if (formatedDate === today) {
        formatedDate = `${second.split(':')[0]}:${second.split(':')[1]}`
      } else if (formatedDate === yesterday) {
        formatedDate = 'Yesterday '
      } else {
        formatedDate = `${date}/${day} `
      }

      return formatedDate
    }
    return ''
})

const routes = [
  { name: 'Home', path: '/', component: Login },
  { name: 'Login', path: '/login', component: Login },
  { name: 'ResetEmail', path: '/login/reset/email', component: ResetEmail },
  { name: 'ForgotPassword', path: '/auth/forgot_password', component: ResetEmail },
  { name: 'ResetPassword', path: '/login/reset/password/:token', component: ResetPassword },
  { name: 'TokenLogin', path: '/login/:token', component: TokenLogin },
  { name: 'Selection', path: '/phone', meta: { requiresAuth: true }, component: Selection },
  { name: 'Bandwidth', path: '/phone/bandwidth', meta: { requiresAuth: true }, component: Bandwidth }
]

const i18n = new VueI18n({
  locale: 'en', // set locale
  fallbackLocale: 'en', // set fallback locale
  messages: i18nOptions, // set locale messages
})

const router = new VueRouter({
  routes,
})

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth) {
    if (localStorage.getItem('fonestorm-token')) {
      next()
    } else {
      router.push({ name: 'Login' })
    }
  } else {
    next()
  }
})

new Vue({
  router,
  i18n,
  template: '<App/>',
  components: { App },
  render: h => h(App)
}).$mount('#app')
